import React from "react";
import {LoadingOutlined} from "@ant-design/icons";

export const LoadingIcon: React.FC = () => {
    return (
        <span className="inline-flex w-[18px] justify-center">
      <LoadingOutlined spin/>
    </span>
    );
};